import { createMiddleware } from '../../../shared/redux';
import { GET_SUBSCRIPTION_REQUEST_SUCCEEDED } from './subscription.state';
import { getInitialOrderSimulation } from '../order/simulation/simulation.state';

export const subscriptionMiddlewares = createMiddleware({
    [GET_SUBSCRIPTION_REQUEST_SUCCEEDED]: () => getInitialOrderSimulation(),
});
